import {
  Component,
  OnInit,
  EventEmitter,
  Output,
  ChangeDetectorRef,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ToastrService } from 'ngx-toastr';
import { SettingService } from '../services/settingService/setting.service';
import * as jwt_decode from 'jwt-decode';
import { CommonService } from 'src/app/middleware/common/common.service';
import {
  ConfirmDialogModel,
  ConfirmDialogComponent,
} from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { Observable, Subscription } from 'rxjs';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';

@Component({
  selector: 'app-edit-custom-field',
  templateUrl: './edit-custom-field.component.html',
  styleUrls: ['./edit-custom-field.component.scss'],
})
export class EditCustomFieldComponent implements OnInit {
  getFieldModel = {
    userID: '',
    organizationID: 0,
    databaseID: 0,
    folderID: 0,
    fieldID: 0,
    officeID: 0,
    OfficeIDList:[]
  };
  deactivateModel = {
    userID: '',
    organizationID: 0,
    databaseID: 0,
    fieldID: 0,
    folderID: 0,
    subFolderID: 0,
    isActive: false,
    isRequired: true,
    requestType: 0,
    officeID: 0,
    OfficeIDList:[]
  };
  deactivateResponseHolder: any;

  deactivedrapDropList: any[] = [];
  databaseId: string;
  organizationId: string;
  currentUser: any;
  getFieldsListResponseHolder: any;
  fieldsList: any[] = [];

  clickEventsubscriptionFeilds: Subscription;

  @Output() openEditSlide = new EventEmitter<boolean>();
  CompanyName:string="";
  CoreName:string="";
  ContactName:string="";
  OfficeIDList: any = [];
  myOfficeID: any;

  constructor(private commonService: CommonService, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private settingsService: SettingService,
    private statusConst: StatusConstant, private change: ChangeDetectorRef, private dialog: MatDialog,
    private loaderService: LoaderService,private toastr: ToastrService,private _dataSharingService: DataSharingService) {
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    const encryptedtoken = sessionStorage.getItem('userToken');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);
    var offices=JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
    this.OfficeIDList.push(oe.officeID)	
    if(oe.isMyoffice==true)
      this.myOfficeID=oe.officeID;
    });
  }

  ngOnDestroy() {
    this.clickEventsubscriptionFeilds.unsubscribe();      
  }

  ngOnInit(): void {
    this.clickEventsubscriptionFeilds = this._dataSharingService.getClickEventforCustomFields().subscribe(() => {
        this.getAllFields();
      });
    this.getAllFields();
  }

  getAllFields() {
    this.getFieldModel.databaseID = Number(this.databaseId);
    this.getFieldModel.organizationID = Number(this.organizationId);
    this.getFieldModel.userID = this.currentUser.UID;
    this.getFieldModel.folderID = 0;
    this.getFieldModel.fieldID = 0;
    this.getFieldModel.officeID = this.myOfficeID;
    this.getFieldModel.OfficeIDList = this.OfficeIDList;
    this.loaderService.show();
    this.settingsService.getFolderListForTab(this.getFieldModel).subscribe((response) => {
        if (response != undefined) {
          this.getFieldsListResponseHolder = response;
          if(this.getFieldsListResponseHolder.status == this.statusConst.statusSuccess) {
            this.fieldsList = this.getFieldsListResponseHolder.data.activeFields.filter(s => s.fieldTypeName != 'Image');
            this.deactivedrapDropList = this.getFieldsListResponseHolder.data.inActiveFields;
            this.loaderService.hide();
          }else{
            this.loaderService.hide();
          }
        }else{
          this.loaderService.hide();
        }
      });
  }

  editField(type: string, item: any, message?: boolean) {
    this.openEditSlide.emit(item);
    this.commonService.setFieldData(item, '');
  }

  deactivateField(fieldDetails: any, status: any) {
    this.deactivateFieldDialog(fieldDetails,status);
  }

  deactivateFieldDialog(data: { fieldID: number; }, status: boolean) {
    var message: string;
    if (status == true) {
      message = `Are you sure you want to activate this field?`;
    } else {
      message = `Are you sure you want to deactivate this field?`;
    }
    const title = `Confirm`;
    const confirm = `Confirm`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });

    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          this.loaderService.show();
          this.deactivateModel.userID = this.currentUser.UID;
          this.deactivateModel.organizationID = Number(this.organizationId);
          this.deactivateModel.databaseID = parseInt(sessionStorage.getItem('databaseId'));
          this.deactivateModel.fieldID = data.fieldID;
          this.deactivateModel.folderID = 0;
          this.deactivateModel.subFolderID = 0;
          this.deactivateModel.requestType = 0;
          this.deactivateModel.isActive = status;
          this.deactivateModel.officeID=this.myOfficeID;
          this.deactivateModel.OfficeIDList=this.OfficeIDList;
          const result = await this.settingsService.deactivateFields(this.deactivateModel).toPromise();
          this.deactivateResponseHolder = result;
          this.loaderService.hide();
          if(this.deactivateResponseHolder.status == this.statusConst.statusSuccess) {
            if (status == true){
              this.toastr.success('Field activated successfully.', '', {
                timeOut: 3000,
              });
            } else{
              this.toastr.success('Field deactivated successfully.', '', {
                timeOut: 3000,
              });
            }           
            this.getAllFields();
            return result;
          } else {
            this.loaderService.hide();
            this.toastr.error(this.deactivateResponseHolder.message, '', {
              timeOut: 3000,
            });
          }
        } else {
          this.loaderService.hide();        
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }

  activateField(fieldDetails, fieldFolderType) {
    this.activateFieldDialog(fieldDetails, fieldFolderType);
  }

  activateFieldDialog(data, fieldFolderType) {
    const message = `Are you sure you want to activate this field?`;
    const title = `Confirm`;
    const confirm = `Confirm`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });

    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          this.loaderService.show();
          this.deactivateModel.userID = this.currentUser.UID;
          this.deactivateModel.organizationID = Number(this.organizationId);
          this.deactivateModel.databaseID = parseInt(sessionStorage.getItem('databaseId'));
          this.deactivateModel.fieldID = data.fieldID;
          this.deactivateModel.folderID = 0;
          this.deactivateModel.subFolderID = 0;
          this.deactivateModel.requestType = 0;
          this.deactivateModel.isActive = true;
          this.deactivateModel.officeID=this.myOfficeID;
          this.deactivateModel.OfficeIDList=this.OfficeIDList;
          const result = await this.settingsService.deactivateFields(this.deactivateModel).toPromise();
          this.deactivateResponseHolder = result;
          this.loaderService.hide();
          if(this.deactivateResponseHolder.status == this.statusConst.statusSuccess) {
            this.toastr.success('Activated successfully.', '', {
              timeOut: 3000,
            });
            this.getAllFields();
            return result;
          } else {
            this.toastr.error(this.deactivateResponseHolder.message, '', {
              timeOut: 3000,
            });
          }
        } else {
          this.toastr.error(this.deactivateResponseHolder.message, '', {
            timeOut: 3000,
          });
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }

  async isRequiredfield(data) {
    this.deactivateModel.userID = this.currentUser.UID;
    this.deactivateModel.organizationID = Number(this.organizationId);
    this.deactivateModel.databaseID = parseInt(sessionStorage.getItem('databaseId'));
    this.deactivateModel.fieldID = data.fieldID;
    this.deactivateModel.folderID = 0;
    this.deactivateModel.subFolderID = 0;
    this.deactivateModel.requestType = 1;
    this.deactivateModel.officeID=this.myOfficeID;
    this.deactivateModel.OfficeIDList=this.OfficeIDList;
    if (data.isRequired == true) {
      this.deactivateModel.isRequired = false;
    } else {
      this.deactivateModel.isRequired = true;   
     }
    const result = await this.settingsService.deactivateFields(this.deactivateModel).toPromise();
    this.deactivateResponseHolder = result;
    if(this.deactivateResponseHolder.status == this.statusConst.statusSuccess) {
      this.toastr.success('Record update successfully.', '', {
        timeOut: 3000,
      });
      this.getAllFields();
      return result;
    } else {
      this.toastr.error(this.deactivateResponseHolder.message, '', {
        timeOut: 3000,
      });
    }
  }
}
